{/* Auto-generated icon - do not edit */}
import React from 'react'

interface PlayIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string
}

export const PlayIcon = React.forwardRef<SVGSVGElement, PlayIconProps>(
  ({ size = 24, color = "currentColor", ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 105 122"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        
<g clip-path="url(#clip0)">
<path d="M100.079 47.7886C99.5644 47.3264 99.0229 46.8946 98.4574 46.4953C96.7837 45.3084 95.1008 44.0631 93.4732 42.8612C89.8059 40.0503 85.9982 37.4267 82.0644 35.0007C65.0248 24.8922 45.7854 15.6235 23.246 6.66619C19.775 5.28656 16.2527 3.96594 12.521 2.56813C10.7186 1.89259 8.85634 1.19371 6.90699 0.45457C6.7572 0.397786 6.59196 0.396647 6.44139 0.451322C6.29081 0.505997 6.16488 0.612835 6.08663 0.752424C5.89163 1.09896 5.65768 1.45001 5.43148 1.7907C4.84191 2.55035 4.41708 3.42416 4.18408 4.35658C3.5241 7.87087 3.09232 11.4241 2.8913 14.994C2.7912 17.3968 2.68959 19.7994 2.58645 22.2017C2.04695 34.8761 1.4886 47.9813 1.28645 60.8782C1.09145 73.2265 1.14085 85.7814 1.1883 97.923C1.2078 102.875 1.22205 107.827 1.23115 112.779V112.953C1.19337 114.265 1.27166 115.577 1.46514 116.875C1.58305 117.743 1.8996 118.572 2.39015 119.298C2.88071 120.024 3.53214 120.628 4.29398 121.062C5.04979 121.462 5.89311 121.668 6.74838 121.662C7.66456 121.653 8.56884 121.454 9.40422 121.078C10.2631 120.671 11.0815 120.185 11.8482 119.624C12.1895 119.39 12.5308 119.157 12.8785 118.939C14.9741 117.623 17.0676 116.303 19.1588 114.98C23.7439 112.087 28.4844 109.096 33.1774 106.207C39.8485 102.1 46.5271 98.0048 53.213 93.9223C61.5375 88.8288 70.146 83.5614 78.5902 78.3433C86.5046 73.4523 93.6051 67.3432 100.199 61.5058C102.894 59.121 104.153 56.984 104.164 54.779C104.174 52.5285 102.875 50.3084 100.079 47.7886ZM11.0748 10.4948L11.2405 10.5598C11.8316 10.7604 12.3947 11.0353 12.9162 11.3781C19.7308 16.4203 26.9751 20.556 35.7553 25.214C48.6903 32.0778 59.5069 37.8904 70.2559 43.9515C74.0688 46.1014 77.7666 48.6329 81.3429 51.0813C82.6429 51.973 83.9494 52.8652 85.2605 53.742C86.1256 54.3488 86.9563 55.0033 87.7486 55.7024C88.0977 55.997 88.4702 56.3111 88.8777 56.6485C85.9703 59.9252 82.6884 62.8505 79.0991 65.3646C73.1841 69.4789 67.3777 73.4763 61.3913 77.1266C48.5629 84.9521 35.4471 92.7932 22.763 100.377L12.8941 106.282C12.4265 106.532 11.9319 106.728 11.4199 106.866L11.3549 106.885C10.3468 96.642 10.1258 24.5106 11.0748 10.4948Z" fill={color}/>
</g>
<defs>
<clipPath id="clip0">
<rect width="104" height="122" fill={color} transform="translate(0.777344)"/>
</clipPath>
</defs>

      </svg>
    )
  }
)

PlayIcon.displayName = 'PlayIcon'
